routerConfig.$inject = ['$routeProvider'];

export default function routerConfig($routeProvider) {
  'ngInject';
  $routeProvider
    .when('/', {
      templateUrl: '/home.html'
    })
    .when('/artikel/lager', {
      templateUrl: '/artikel/lager.html'
    })
    .when('/artikel/:id', {
      templateUrl: '/artikel/artikel.html'
    })
    .when('/anfragen/:id', {
      templateUrl: '/anfragen/anfrage.html'
    })
    .when('/kunden', {
      templateUrl: '/kunden/kunden.html'
    })
    .when('/kunden/:id', {
      templateUrl: '/kunden/kunde.html'
    })
    .when('/kontakt', {
      templateUrl: '/kontakt/kontakt.html'
    })
    .when('/rechnungen', {
      templateUrl: '/rechnungen/rechnungen.html'
    })
    .when('/rechnungen/neu', {
      templateUrl: '/rechnungen/rechnungNeu.html'
    })
    .when('/rechnungen/:id', {
      templateUrl: '/rechnungen/rechnung.html'
    })
    .when('/login', {
      templateUrl: '/login/login.html'
    })
    .otherwise({
      redirectTo: '/'
    });
}



// WEBPACK FOOTER //
// ./app/index.route.js